import React, { useState } from 'react';
import { NavLink as RouterLink, matchPath } from 'react-router-dom';

import clsx from 'clsx';

import { connect } from 'react-redux';

import {
  Tooltip,
  IconButton,
  Popover,
  List,
  ListItem,
  Typography
} from '@material-ui/core';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';

import useRouter from 'utils/useRouter';

import navItems from '../Sidebar/navItems';

import { setSidebarToggle } from '../../reducers/ThemeOptions';

// Normaliza el "to" (puede ser string o arreglo) al destino navegable.
const primaryTarget = to => (Array.isArray(to) ? to[0] : to);

// ¿La ruta actual corresponde a esta opción (o a alguna de sus subrutas)?
const isActive = (location, to) => {
  if (!to) return false;
  const paths = Array.isArray(to) ? to : [to];
  return paths.some(p =>
    Boolean(matchPath(location.pathname, { path: p, exact: false }))
  );
};

const renderIcon = item => {
  if (item.fai) {
    return (
      <FontAwesomeIcon
        icon={item.fai}
        className="app-sidebar-rail-fa"
        style={{ height: '1.125em', width: '1.125em' }}
      />
    );
  }
  const Icon = item.icon;
  return Icon ? <Icon /> : null;
};

const SidebarRail = props => {
  const { setSidebarToggle } = props;

  const router = useRouter();

  const [anchorEl, setAnchorEl] = useState(null);
  const [flyout, setFlyout] = useState(null);

  const openFlyout = (event, item) => {
    setAnchorEl(event.currentTarget);
    setFlyout(item);
  };

  const closeFlyout = () => {
    setAnchorEl(null);
    setFlyout(null);
  };

  // navItems agrupa el menú; aplanamos sus opciones de primer nivel.
  const items = navItems.reduce(
    (acc, group) => acc.concat(group.content),
    []
  );

  return (
    <div className="app-sidebar-rail">
      <div className="app-sidebar-rail-spacer" />

      <div className="app-sidebar-rail-items">
        {items.map(item => {
          const active = isActive(router.location, item.to);

          if (item.content) {
            // Opción con hijos: al hacer clic abre el submenú flotante.
            return (
              <Tooltip
                key={item.label}
                title={item.label}
                placement="right"
                arrow>
                <IconButton
                  className={clsx('app-sidebar-rail-btn', { active })}
                  onClick={event => openFlyout(event, item)}
                  size="medium">
                  {renderIcon(item)}
                </IconButton>
              </Tooltip>
            );
          }

          // Opción simple: navega directamente.
          return (
            <Tooltip
              key={item.label}
              title={item.label}
              placement="right"
              arrow>
              <IconButton
                className={clsx('app-sidebar-rail-btn', { active })}
                component={RouterLink}
                to={primaryTarget(item.to)}
                size="medium">
                {renderIcon(item)}
              </IconButton>
            </Tooltip>
          );
        })}
      </div>

      <div className="app-sidebar-rail-footer">
        <Tooltip title="Expandir menú" placement="right" arrow>
          <IconButton
            className="app-sidebar-rail-expand"
            onClick={() => setSidebarToggle(false)}
            size="medium">
            <ChevronRightRoundedIcon />
          </IconButton>
        </Tooltip>
      </div>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={closeFlyout}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        classes={{ paper: 'app-sidebar-flyout' }}>
        {flyout && (
          <React.Fragment>
            <Typography className="app-sidebar-flyout-title">
              {flyout.label}
            </Typography>
            <List className="p-0">
              {flyout.content.map(child => (
                <ListItem
                  button
                  key={child.label}
                  component={RouterLink}
                  to={primaryTarget(child.to)}
                  activeClassName="active"
                  className="app-sidebar-flyout-item"
                  onClick={closeFlyout}>
                  {child.label}
                </ListItem>
              ))}
            </List>
          </React.Fragment>
        )}
      </Popover>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  setSidebarToggle: enable => dispatch(setSidebarToggle(enable))
});

export default connect(null, mapDispatchToProps)(SidebarRail);
